/// <amd-module name="Wit/BacklogsHub/Common/Services/BacklogsViewService" />
import { getTFSPageData } from "Tfs/Platform/Page";
import { IVssPageContext, IVssService, Services, VssService } from "VSS/Platform/Context";
import { routeUrl } from "VSS/Platform/Location";
import { Routes } from "Wit/BacklogsHub/Common/BacklogHubContants";

export interface IBacklogsViewService extends IVssService {
    getBoardsUrl(backlogLevel: string, teamName: string): string;
}

export class BacklogsViewService extends VssService implements IBacklogsViewService {
    public _serviceStart = (pageContext: IVssPageContext): void => {
        super._serviceStart(pageContext);
    };

    public _serviceEnd = (pageContext: IVssPageContext): void => {
        super._serviceEnd(pageContext);
    };

    public getBoardsUrl(backlogLevel: string, teamName: string): string {
        const routeValues: { [key: string]: string } = this.getDefaultRouteValues();
        routeValues["pivot"] = "board";
        routeValues["teamName"] = teamName;

        if (backlogLevel) {
            routeValues["backlogLevel"] = backlogLevel;
        }
        return routeUrl(this.pageContext, Routes.BoardsHubContent, routeValues);
    }

    public getDefaultRouteValues(): { [key: string]: string } {
        const routeValues: { [key: string]: string } = {};
        const projectName = getTFSPageData(this.pageContext)?.project?.name;
        routeValues["project"] = projectName || "";

        return routeValues;
    }
}

Services.add("IBacklogsViewService", { serviceFactory: BacklogsViewService });
